import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { Buyer } from "../../../types/models/Buyer";
import BuyerUserListItem from "../../../../timber/components/buyerUser/BuyerUserList/BuyerUserListItem";
import ShipmentListItem from "../../../../timber/components/shipment/ShipmentList/ShipmentListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";
import GenericRootReport, {defaultFormOptions} from "../../generic/report/GenericRootReport.tsx";
import {toString} from "../../../types/models/Buyer.ts";
import PriceCalculator from "../../generic/priceCalculator/PriceCalculator.tsx";
import {formatDateTimeParam} from "../../../../utils/formatDate.ts";
import {endOfMonth, startOfMonth} from "date-fns";

type IFormProps = {
    data: Buyer;
};

const BuyerTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'shipment');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    const now = new Date();
    const customizeFiler = (filter: Record<string, string>): Record<string, string> =>  { return {
        ...filter,
        buyerId: data.id
    }}
    const reportTitle = `Buyer ${toString(data)}`
    const formOptions = {
        ...defaultFormOptions,
        showCreateDate: false,
    }

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="Buyer-tabs"
            >
                { session.hasPermission('', 'applications/timber/entities/Shipments/list/view') &&
                    <Tab label={t`Shipments`} value="shipment"/>
                }
                { session.hasPermission('', 'applications/timber/entities/BuyerUsers/list/view') &&
                    <Tab label={t`Buyer Users`} value="buyerUser"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Buyers/report/view') &&
                    <Tab label={t`Report`} value="report"/>
                }
                { session.hasPermission('', 'applications/timber/entities/PricingProfiles/view') &&
                    <Tab label={t`Price Calculator`} value="priceCalculatorReport"/>
                }
                </Tabs>

            { session.hasPermission('', 'applications/timber/entities/Shipments/list/view') &&
                <TabPanel value={tabValue} index="shipment" data-testid="Shipment-tab">
                    <ShipmentListItem buyerId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/BuyerUsers/list/view') &&
                <TabPanel value={tabValue} index="buyerUser" data-testid="BuyerUser-tab">
                    <BuyerUserListItem buyerId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Buyers/report/view') &&
                <TabPanel value={tabValue} index="report">
                    <GenericRootReport
                        shipmentDefined={true}
                        mainTitle={reportTitle}
                        customizeFiler={customizeFiler}
                        formOptions={formOptions}
                        initialState={
                            {
                                startShipment: formatDateTimeParam(startOfMonth(now)),
                                endShipment: formatDateTimeParam(endOfMonth(now)),
                            }
                        }
                    />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/PricingProfiles/view') &&
                <TabPanel value={tabValue} index="priceCalculatorReport">
                    <PriceCalculator
                        shipmentDefined={null}
                        customizeFiler={customizeFiler}
                        formOptions={formOptions}
                    />
                </TabPanel>
            }
            
        </Box>
    )
}

export default BuyerTabs;
